import { Providers } from "@/app/providers";
import AppRouter from "@/app/router";
import { ErrorFallback } from "@/app/error-boundaries/ErrorFallback";
import { GlobalToastContainer } from "@/components/ui/GlobalToastContainer";
import { LoadingScreen } from "@/components/ui/LoadingScreen";
import { queryClient } from "@/infrastructure/query/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Suspense } from "react";

import * as Sentry from "@sentry/react";

const App = () => {
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog={false}>
      <QueryClientProvider client={queryClient}>
        <Providers>
          <Suspense
            fallback={
              <LoadingScreen variant="branded" size="lg" message="Inicializando aplicación" />
            }
          >
            <AppRouter />
          </Suspense>
          <GlobalToastContainer />
        </Providers>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
